import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ApproveStatus } from "../api/approveStatus.js";
import Spinner from 'react-bootstrap/Spinner';

const ModalComponent = ({ openPopup, handleClosePopup, userDetails }) => {
    const [userId, setUserId] = useState(userDetails.userId);
    const [catalogItemId, setCatalogItemId] = useState(userDetails.catalogItemId);
    const [directLinkId, setDirectLinkId] = useState(userDetails.directLinkId);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'userId':
                setUserId(value);
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    userId: value.trim() ? '' : 'User ID is required',
                }));
                break;
            case 'catalogItemId':
                setCatalogItemId(value);
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    catalogItemId: value.trim() ? '' : 'Catalog Item ID is required',
                }));
                break;
            case 'directLinkId':
                setDirectLinkId(value);
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    directLinkId: value.trim() ? '' : 'Direct Link ID is required',
                }));
                break;
            default:
                break;
        }
    };

    const validateSaveData = () => {
        const newErrors = {};
        if (!userId.trim()) {
            newErrors.userId = "User ID is required";
        }
        if (!catalogItemId.trim()) {
            newErrors.catalogItemId = "Catalog Item ID is required";
        }
        if (!directLinkId.trim()) {
            newErrors.directLinkId = "Direct Link ID is required";
        }
        return newErrors;
    };

    const handleSave = async () => {
        const errorss = validateSaveData();
        setErrors(errorss);

        if (Object.keys(errorss).length > 0) {
            return;
        }

        console.log("User ID:", userId);
        console.log("Catalog Item ID:", catalogItemId);
        console.log("Direct Link ID:", directLinkId);
        console.log(userDetails, "userDetails");
        setIsLoading(true)
        await ApproveStatus(userId, catalogItemId, directLinkId, userDetails.priorities, userDetails);
        setIsLoading(false)
        handleClosePopup();
        toast.success("Data Saved");
    };

    return (
        <Modal show={openPopup} onHide={handleClosePopup}>
            <Modal.Header closeButton>
                <Modal.Title>User Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="userId">
                        <Form.Label>User ID</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter User ID"
                            name="userId"
                            value={userId}
                            onChange={handleInputChange}
                            onBlur={handleInputChange}
                            isInvalid={!!errors.userId}
                            required
                        />

                        <Form.Control.Feedback type="invalid">
                            {!userId && <>{errors.userId}</>}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="catalogItemId">
                        <Form.Label className="mt-4">Catalog Item Type ID</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Catalog Item ID"
                            name="catalogItemId"
                            value={catalogItemId}
                            onChange={handleInputChange}
                            onBlur={handleInputChange}
                            isInvalid={!!errors.catalogItemId}
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            {!catalogItemId && <>{errors.catalogItemId} </>}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="directLinkId">
                        <Form.Label className="mt-4">Direct Link Logo ID</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Direct Link ID"
                            name="directLinkId"
                            value={directLinkId}
                            onChange={handleInputChange}
                            onBlur={handleInputChange}
                            isInvalid={!!errors.directLinkId}
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            {!directLinkId && <> {errors.directLinkId} </>}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="mt-3">
                <Button
                    style={{ backgroundColor: "#212529", color: "white" }}
                    onClick={handleClosePopup}
                >
                    Close
                </Button>
                <Button
                    style={{ backgroundColor: "#043174", color: "white" }}
                    onClick={handleSave}
                >
                    {isLoading ?
                        <Spinner animation="border" size="sm" />
                        :
                        "Save and Approve"
                    }
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalComponent;
